import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ordersService } from '../../../services/orders.service';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import * as moment from 'moment';
 
interface DropdownOption {
  id: any;
  vehicleType: string;
}
 
interface OrderTypeOption {
  value: 'Contract' | 'Spot';
  label: string;
  description: string;
  icon: string;
}
 
interface RateTypeOption {
  value: 'RATE_KNOWN' | 'NULL_PRICE';
  label: string;
}

@Component({
  selector: 'app-create-tms-order',
  templateUrl: './create-tms-order.component.html',
  styleUrls: ['./create-tms-order.component.css']
})
export class CreateTmsOrderComponent {


  theme = 'dark';
 
  orderForm!: FormGroup;
 
  customers: DropdownOption[] = [];
  kamList: DropdownOption[] = [];
  procurementExecList: DropdownOption[] = [];
  allRoles:any;
 
  vehicleTypeList: DropdownOption[] = [];
  contractList:any;
  orderTypes: OrderTypeOption[] = [
    {
      value: 'Contract',
      label: 'Contract',
      description: 'Rate auto-fetched from Contract Master',
      icon: 'file-text'
    },
    {
      value: 'Spot',
      label: 'Spot',
      description: 'Rate negotiated – KAM & Procurement workflow',
      icon: 'zap'
    }
  ];
 
  customerRateTypes: RateTypeOption[] = [
    { value: 'RATE_KNOWN', label: 'Rate Known' },
    { value: 'NULL_PRICE', label: 'NULL Price' }
  ];

  routes: any;
  locationList: any;
  accounts:any;
  UserDetails:any;
  userRole:any;
  userType:any;
  accountIds:any;
  filters: any;

  accountList: any[] = [];
  accountPage = 0;
  accountSize = 50;
  accountSearchText = '';
  isLoadingAccounts = false;
  hasMoreAccounts = true;
  accountSearch$ = new Subject<string>();
  selectedRouteSourceId: any = null;
  selectedRouteDestinationId: any = null;
  constructor(
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private orderService: ordersService,
    private emsServices: EmsServicesService
  ) {
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.UserDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userRole = this.UserDetails?.roleName
    this.userType = this.UserDetails?.userType;
    console.log(this.userType,'======')
    this.accountIds = Array.from(new Set(this.UserDetails.accountMapping.map((m:any) => m.accountId)));
  }
 
  ngOnInit(): void {
    this.accountSearch$
    .pipe(
      debounceTime(500), // wait 500ms after typing stops
      distinctUntilChanged()
    )
    .subscribe((searchText: string) => {
      this.accountSearchText = searchText;
      this.getAccounts(true);
    });
    this.getRoles()
    this.getCustomers();
    this.getVehicleType();
    this.getLocations()
    this.getAccounts(true);
    this.buildForm();
    this.routeDetails.get('routeId')?.valueChanges.subscribe((routeId: any) => {
      this.onRouteChange(routeId);
    });
    this.loadDropdownData();
 
    // Re-evaluate pricing validators whenever order type or rate type changes
    this.orderForm.get('orderType')?.valueChanges.subscribe(() => {
      this.updatePricingValidators();
    });
 
    this.orderForm.get('customerRateType')?.valueChanges.subscribe(() => {
      this.updatePricingValidators();
    });
 
    // If opened in "edit" mode, patch existing data
    const editData = this.config?.data?.editData?.[0];
    if (this.config?.data?.edit && editData) {
      this.patchForm(editData);
    }
  }

  getCustomers(){
  this.emsServices.getB2bCustomers([], 0, 100000).subscribe((data: any) => {
      this.customers = data?.responseObject?.content;
    });
  }
  
  getRoles(){
    this.emsServices.getRoles().subscribe((res:any)=>{
      this.allRoles = res?.responseObject;
      this.allRoles.forEach((el:any)=>{
        if(el.name === 'ROLE_KAM'){
          this.getKam(el.id)
        }
        if(el.name === 'ROLE_PROCUREMENT'){
          this.getProcurement(el.id)
        }
      })
    })
  }

  getKam(id:any){
    const postData = [
      {
        "key": "ROLE_ID_IN",
        "value": id.toString()
      }
    ]
    this.emsServices.getUsers(postData,0,100000,'id','DESC').subscribe((res:any)=>{
      this.kamList = res?.responseObject?.content;
    })
  }

  getProcurement(id:any){
    const postData = [
      {
        "key": "ROLE_ID_IN",
        "value": id.toString()
      }
    ]
    this.emsServices.getUsers(postData,0,100000,'id','DESC').subscribe((res:any)=>{
      this.procurementExecList = res?.responseObject?.content;
    })
  }

  getVehicleType(){
    this.emsServices.getVehicleType([],0,100000).subscribe((res:any)=>{
      this.vehicleTypeList = res?.responseObject?.content;
    })
  }

  customerChange(event:any){
    if(event){
      this.getCustomerContracts(event.id)
    }
  }

  getCustomerContracts(id:any){
    const postData = [
      {
        "key": "CUSTOMER_ID",
        "value": id.toString()
      }
    ]
    this.emsServices.getCustomerContracts(postData,0,100000).subscribe((res:any)=>{
      this.contractList = res?.responseObject?.content || [];

      this.routes = this.contractList.map((item: any) => ({
        id: item.routeId,
        name: `${item.sourceCity} - ${item.destinationCity}`,
        agreedCost: item.agreedCost
      }));
    })
  }

  onRouteChange(routeId: any): void {
    const selectedRoute = this.contractList.find(
      (x: any) => x.routeId == routeId
    );
  
    if (selectedRoute) {
      this.routeDetails.patchValue({
        price: selectedRoute.agreedCost
      });
  
      // Store sourceId and destinationId from selected contract route
      this.selectedRouteSourceId = selectedRoute.sourceId;
      this.selectedRouteDestinationId = selectedRoute.destinationId;
    }
  }

  getAccounts(reset: boolean = false) {
    if (this.isLoadingAccounts) {
      return;
    }
  
    if (reset) {
      this.accountPage = 0;
      this.accountList = [];
      this.hasMoreAccounts = true;
    }
  
    if (!this.hasMoreAccounts) {
      return;
    }
  
    let filters: any[] = [];
  
    if (this.userRole !== 'ROLE_SUPERUSER' && this.accountIds?.length > 0) {
      filters.push({
        key: 'ACCOUNT_ID_IN',
        value: this.accountIds.join(',')
      });
    }
    if (this.accountSearchText?.trim()) {
      filters.push({
        key: 'ACCOUNT_NAME_IN',
        value: this.accountSearchText.trim()
      });
    }
    this.isLoadingAccounts = true;
    this.emsServices
      .getAccounts(
        filters,
        this.accountPage,
        this.accountSize,
        'id',
        'DESC'
      )
      .subscribe({
        next: (data: any) => {
          const content = data?.responseObject?.content || [];
          this.accountList = [...this.accountList, ...content];
          this.hasMoreAccounts = content.length === this.accountSize;
          if (content.length > 0) {
            this.accountPage++;
          }
          this.isLoadingAccounts = false;
        },
        error: () => {
          this.isLoadingAccounts = false;
        }
      });
  }

  onAccountSearch(event: any) {
    this.accountSearch$.next(event.term || '');
  }
  loadMoreAccounts() {
    this.getAccounts(false);
  }
  getLocations() {
    this.emsServices.getLocations([], 0, 100000).subscribe((res: any) => {
  
      this.locationList = res?.responseObject?.content || [];
  
      this.locationList.unshift({
        id: -1,
        cityName: 'Others'
      });
  
    });
  }
  // ---------- Form setup ----------
 
  buildForm(): void {
    this.orderForm = this.fb.group({
      customer: [null, Validators.required],
      accountId: [null],
      // vehiclePlacementDate: [null, Validators.required],
      assignedKam: [null],
      assignedProcurementExec: [null],
      placementDateTime: [null, Validators.required],
      orderType: ['Spot', Validators.required],
      routeDetails: this.createRouteDetail(),
      shipmentLineItems: this.fb.array([this.createShipmentLineItem()]),
      customerRateType: ['RATE_KNOWN'],
      customerRate: [null],
      historicalRate: [null]
    });
 
    this.updatePricingValidators();
  }

  asFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }
 
  // ---------- Order type / pricing ----------
 
  selectOrderType(type: string): void {
    this.orderForm.get('orderType')?.setValue(type);
  }
 
  selectCustomerRateType(type: string): void {
    this.orderForm.get('customerRateType')?.setValue(type);
  }
 
  updatePricingValidators(): void {
    const orderType = this.orderForm.get('orderType')?.value;
    const rateType = this.orderForm.get('customerRateType')?.value;
    const rateControl = this.orderForm.get('customerRate');
  
    if (orderType === 'Spot' && rateType === 'RATE_KNOWN') {
      rateControl?.setValidators([Validators.required, Validators.min(0)]);
    } else {
      rateControl?.clearValidators();
    }
    rateControl?.updateValueAndValidity();
  
    // Clear shipment validators when Contract, apply when Spot
    const sourceId = this.shipmentLineItems.at(0)?.get('sourceId');
    const destinationId = this.shipmentLineItems.at(0)?.get('destinationId');
  
    if (orderType === 'Contract') {
      sourceId?.clearValidators();
      destinationId?.clearValidators();
    } else {
      sourceId?.setValidators([Validators.required]);
      destinationId?.setValidators([Validators.required]);
    }
  
    sourceId?.updateValueAndValidity();
    destinationId?.updateValueAndValidity();
  }
 
  // ---------- Validation helpers ----------
 
  isInvalid(controlName: string): boolean {
    const control = this.orderForm.get(controlName);
    return !!control && control.touched && control.invalid;
  }
 
  // isLineItemInvalid(index: number, controlName: string): boolean {
  //   const control = this.lineItems.at(index).get(controlName);
  //   return !!control && control.touched && control.invalid;
  // }

  createLocation(): FormGroup {
    return this.fb.group({
      pincode: [''],
      city: [null],
      otherCity: [''],
      address: ['']
    });
  }
  
  createShipmentLineItem(): FormGroup {
    return this.fb.group({
      sourceId: [null, Validators.required],
      originAddress: [''],
  
      destinationId: [null, Validators.required],
      destinationAddress: [''],
  
      vehicleType: [null],
      trucks: [1]
    });
  }
  
  get shipmentLineItems(): FormArray {
    return this.orderForm.get('shipmentLineItems') as FormArray;
  }
  
  addLineItem(): void {
    this.shipmentLineItems.push(this.createShipmentLineItem());
  }
  
  removeLineItem(index: number): void {
    if (this.shipmentLineItems.length > 1) {
      this.shipmentLineItems.removeAt(index);
    }
  }

  createRouteDetail(): FormGroup {
    return this.fb.group({
      routeId: [null],
      vehicleType: [null],
      noOfVehicle: [1, [Validators.required, Validators.min(1)]],
      price: [null],
  
      pickupLocations: this.fb.array([
        this.createLocation()
      ]),
  
      dropLocations: this.fb.array([
        this.createLocation()
      ])
    });
  }
  get routeDetails(): FormGroup {
    return this.orderForm.get('routeDetails') as FormGroup;
  }
  
  get pickupLocations(): FormArray {
    return this.routeDetails.get('pickupLocations') as FormArray;
  }
  
  get dropLocations(): FormArray {
    return this.routeDetails.get('dropLocations') as FormArray;
  }
  
  addPickupLocation(): void {
    this.pickupLocations.push(this.createLocation());
  }
  
  removePickupLocation(index: number): void {
    if (this.pickupLocations.length > 1) {
      this.pickupLocations.removeAt(index);
    }
  }
  
  addDropLocation(): void {
    this.dropLocations.push(this.createLocation());
  }
  
  removeDropLocation(index: number): void {
    if (this.dropLocations.length > 1) {
      this.dropLocations.removeAt(index);
    }
  }
  // ---------- Data loading ----------
 
  loadDropdownData(): void {
    const accounts = JSON.parse(localStorage.getItem('accountList') || '[]');
    this.customers = (accounts || []).map((acc: any) => ({
      id: acc.id,
      name: acc.accountName
    }));
 
    // TODO: replace with real services for KAM / Procurement Exec lists
  }
 
  patchForm(data: any): void {
    this.orderForm.patchValue({
      customer: data.customerId,
      accountId: data.accountId,
      assignedKam: data.assignedKamId,
      assignedProcurementExec: data.assignedProcurementId,
      placementDateTime: data.vehicleRequiredAt,
      orderType: data.orderType ? (data.orderType.charAt(0).toUpperCase() + data.orderType.slice(1).toLowerCase()) : 'Spot',
      customerRateType: data.isNullPrice ? 'NULL_PRICE' : 'RATE_KNOWN',
      customerRate: data.customerAmount,
      historicalRate: data.historicalRate
    });
  
    // Patch shipment line items for Spot
    if (data.orderType?.toLowerCase() === 'spot') {
      this.shipmentLineItems.at(0).patchValue({
        sourceId: data.sourceId,
        originAddress: data.originAddress || '',
        destinationId: data.destinationId,
        destinationAddress: data.destinationAddress || '',
        vehicleType: data.vehicleTypeId,
        trucks: data.numberOfVehicle || 1
      });
    }
  
    // Patch route details for Contract
    if (data.orderType?.toLowerCase() === 'contract') {
      this.routeDetails.patchValue({
        routeId: data.routeId,
        vehicleType: data.vehicleTypeId,
        noOfVehicle: data.numberOfVehicle || 1,
        price: data.customerAmount
      });
    }
  }
 
  // ---------- Actions ----------
 
  onCancel(): void {
    this.ref.close();
  }
 
  getInvalidControls(formGroup: FormGroup | FormArray, path: string = ''): string[] {
    const invalidControls: string[] = [];
  
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      const controlPath = path ? `${path}.${key}` : key;
  
      if (control instanceof FormGroup || control instanceof FormArray) {
        invalidControls.push(...this.getInvalidControls(control, controlPath));
      } else if (control && control.invalid) {
        invalidControls.push(controlPath);
      }
    });
  
    return invalidControls;
  }

  onSubmit(): void {

    if (this.orderForm.invalid) {
      this.orderForm.markAllAsTouched();
      console.log(
        'Invalid Controls:',
        this.getInvalidControls(this.orderForm)
      );
      return;
    }
  
    const formValue = this.orderForm.value;
  
    const payload: any = {
      accountId: formValue.accountId,
      customerId: formValue.customer,
  
      routeId:
        formValue.orderType === 'Contract'
          ? formValue.routeDetails?.routeId
          : null,
  
      vehicleTypeId:
        formValue.orderType === 'Contract'
          ? formValue.routeDetails?.vehicleType
          : formValue.shipmentLineItems?.[0]?.vehicleType,
  
      assignedKamId: formValue.assignedKam,
      assignedProcurementId: formValue.assignedProcurementExec,
  
      vehicleRequiredAt: moment(formValue.placementDateTime).format('DD-mm-yyyy hh:mm:ss') + ' ' +'+0530',
  
      orderType: formValue.orderType?.toLowerCase(),
  
      customerAmount:
        formValue.orderType === 'Contract'
          ? formValue.routeDetails?.price
          : formValue.customerRate,
  
      confirmedAmount:
        formValue.orderType === 'Contract'
          ? formValue.routeDetails?.price
          : formValue.customerRate,
  
      numberOfVehicle:
        formValue.orderType === 'Contract'
          ? formValue.routeDetails?.noOfVehicle
          : formValue.shipmentLineItems?.[0]?.trucks,
  
      isNullPrice:
        formValue.customerRateType === 'NULL_PRICE',
      status: formValue.customerRateType === 'NULL_PRICE' ? 'QUOTE_PENDING' : 'CREATED',
      orderPoints: [],
      tripStatus: "PENDING",
      lhcStatus: "PENDING",
      softPodStatus: "PENDING",
      hardPodStatus: "PENDING",
      advancePaymentStatus: "PENDING",
      balancePaymentStatus: "PENDING",       
    };
  
    // EDIT CASE
    if (this.config?.data?.edit) {
      payload.id = this.config?.data?.editData?.[0]?.id;
    }
  
    // CONTRACT
    if (formValue.orderType === 'Contract') {

      payload.sourceId = this.selectedRouteSourceId;
      payload.destinationId = this.selectedRouteDestinationId;

      formValue.routeDetails.pickupLocations.forEach((pickup: any) => {
        payload.orderPoints.push({
          pointType: 'PICKUP',
          address: pickup.address,
          locationId: pickup.locationId === -1 ? null : pickup.locationId,
          pincode: pickup.pincode
        });
      });
  
      formValue.routeDetails.dropLocations.forEach((drop: any) => {
  
        payload.orderPoints.push({
          pointType: 'DROP',
          address: drop.address,
          locationId:
            drop.locationId === -1
              ? null
              : drop.locationId,
          pincode: drop.pincode
        });
  
      });
    }
  
    // SPOT
    else {
      const spotItem = formValue.shipmentLineItems?.[0];
    
      payload.sourceId = spotItem?.sourceId === -1 ? null : spotItem?.sourceId;
      payload.destinationId = spotItem?.destinationId === -1 ? null : spotItem?.destinationId;
      payload.originAddress = spotItem?.originAddress || '';
      payload.destinationAddress = spotItem?.destinationAddress || '';
    }
  
    console.log(payload);
  
    this.orderService.createUpdateOrder(payload).subscribe((res:any)=>{
      this.ref.close(res)      
    })
  }
}